<app-change-password2 #changePassword [presentation]="'page'"></app-change-password2>
